<div class="mos-form">
  <ul class="breadcrumb">
    <li>
      <a href="/yopaplus/offers/properties/my-properties" target="_self"
        >Offers</a
      >
    </li>
    <li *ngIf="propertyAddress">
      <span>{{ propertyAddress }}</span>
    </li>
    <li>
      <span>Memorandum of Sale</span>
    </li>
  </ul>

  <div class="content-box">
    <div *ngIf="canDoPayment">
      <h2 class="mos-form-title">Buyer administration fee</h2>

      <h4>Debit or credit card accepted</h4>

      <p class="mos-form--text">
        Under Anti Money Laundering regulations all buyers are required to
        undergo a number of checks to ensure proof of identity and funds, a
        third party will be engaged to conduct these checks and our compliance
        team will verify the information.
      </p>

      <p class="mos-form--text">
        Identity checks are valid for 3 months and cost £{{ ccAmount }} inc. VAT, once
        payment is received you will be able to access and complete your
        memorandum of sale.
      </p>

      <app-stripe
        [amount]="ccAmount"
        [description]="description"
        (paymentDone)="onPaymentDone($event)"
      ></app-stripe>
    </div>

    <div *ngIf="!canDoPayment">
      <h2 class="mos-form-title">Buyer administration fee required</h2>

      <p>
        The Memorandum of sale cannot be completed until the buyer has paid
        their administration fee of £{{ ccAmount }} inclusive of VAT.
      </p>

      <a
        href="/yopaplus/properties/manage/{{ propertyId }}/overview"
        target="_self"
        class="button button-primary mt-3"
        >Cancel</a
      >
    </div>
  </div>
</div>
